/** Узкий экран (телефон): панели на всю ширину, кнопки карты внизу,
 *  панель маршрута сворачивается после построения. */
export const MOBILE_QUERY = '(max-width: 640px)';

export const isMobile = (): boolean => window.matchMedia(MOBILE_QUERY).matches;
